var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5035 2.6516C26.7542 1.88 27.8458 1.88 28.0965 2.6516L33.1289 18.1398C33.2411 18.4849 33.5626 18.7185 33.9255 18.7185H50.2108C51.0221 18.7185 51.3594 19.7567 50.703 20.2336L37.5279 29.8059C37.2344 30.0191 37.1116 30.3971 37.2237 30.7422L42.2561 46.2304C42.5068 47.002 41.6237 47.6437 40.9674 47.1668L27.7923 37.5945C27.4987 37.3813 27.1013 37.3813 26.8077 37.5945L13.6326 47.1668C12.9763 47.6437 12.0932 47.002 12.3439 46.2304L17.3763 30.7422C17.4884 30.3971 17.3656 30.0191 17.0721 29.8059L3.89698 20.2336C3.24062 19.7567 3.57794 18.7185 4.38925 18.7185H20.6745C21.0374 18.7185 21.3589 18.4849 21.4711 18.1398L26.5035 2.6516Z",
    fill: "#DFE3E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/Stars.d2102e9f0ce5ea57f31fbc2b78e2e4bf.svg";
export { ForwardRef as ReactComponent };